module.exports = __webpack_public_path__ + "static/media/tcr-logo-light.3c29a8dd.png";